export default "__VITE_ASSET__woyVc80d__"